export { CurrencyDollar as default } from './CurrencyDollar';
